import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationResult } from '../../models/authentication-result';
import { IReviewRequestDto } from '../../models/requests/review.request';
import { UiStateStore } from '../../store/ui-state-store.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {
  @Output() reviewEvent = new EventEmitter<IReviewRequestDto>();
  reviewRating = 0;
  reviewText = '';
  user: AuthenticationResult = null;
  constructor(private uiState: UiStateStore) { }

  ngOnInit(): void {
    this.uiState.authenticatedUser.subscribe(resp => {
      this.user = resp;
    });
  }

  onReviewSave = () => {
    if(!this.reviewText || !this.reviewRating) {
      this.uiState.setError('Please submit with review and rating.');
      return;
    }

    const request: IReviewRequestDto = {
      reviewRating: this.reviewRating,
      reviewText: this.reviewText,
      reviewedBy: this.user.accountId,
      reviewedTo: null,
      jobId: null,
      isClientReview: null
    };

    this.reviewEvent.emit(request);
  };

}
